import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Text, View } from "@/styles/reactnative";
import { ThemeContext } from "@/theme/ThemeProvider";
import { DepositRightSectionWrapper } from "./styles";
import { MView } from "../../../styles/mobilePageStyles";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { goTo } from "../../hooks/navigation";
import styled from "styled-components";

const WithdrawRightSection = () => {
  const { textsilver, descBox } = useContext(ThemeContext).theme.COLORS;
  const { isDarkMode } = useContext(ThemeContext);
  const { t } = useTranslation();
  const nav = useNavigate();
  return (
    <ModernInfoCard isDarkMode={isDarkMode}>
      <InfoHeader>
        <InfoTitle>{t("important")}</InfoTitle>
      </InfoHeader>
      
      <InfoContent>
        <InfoText>
          {t("depositFirstDesc")}
        </InfoText>
        <InfoText>
          {t("depositSecondDesc")}
        </InfoText>
        <InfoText>
          {t("depositFourthDesc")}
        </InfoText>
      </InfoContent>
    </ModernInfoCard>
  );
};

// Styled Components
const ModernInfoCard = styled.div<{ isDarkMode: boolean }>`
  background: ${props => props.isDarkMode
    ? 'linear-gradient(145deg, rgba(60, 60, 60, 0.8) 0%, rgba(45, 45, 45, 0.9) 100%)'
    : 'linear-gradient(145deg, rgba(80, 80, 80, 0.8) 0%, rgba(65, 65, 65, 0.9) 100%)'
  };
  border-radius: 16px;
  padding: 24px;
  border: 1px solid ${props => props.isDarkMode 
    ? 'rgba(255, 255, 255, 0.15)' 
    : 'rgba(255, 255, 255, 0.2)'
  };
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  height: fit-content;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: ${props => props.isDarkMode
      ? '0 8px 25px rgba(0, 0, 0, 0.4)'
      : '0 8px 25px rgba(0, 0, 0, 0.3)'
    };
    border-color: ${props => props.isDarkMode 
      ? 'rgba(255, 92, 23, 0.4)' 
      : 'rgba(255, 92, 23, 0.3)'
    };
  }
`;

const InfoHeader = styled.div`
  margin-bottom: 20px;
`;

const InfoTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #FFFFFF;
  position: relative;
  padding-bottom: 12px;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #FF5C17 0%, #FF8A50 100%);
    border-radius: 2px;
  }
`;

const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InfoText = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #B8BCC8;
  opacity: 0.9;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export default WithdrawRightSection;
